export default __webpack_public_path__ + "static/media/bp1.1ef2d1ab.jpg";